module.exports = __webpack_public_path__ + "static.ibuole.com/venue/build/img/leerweima.7ffb0f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/leerweima.png
// module id = 1Knb
// module chunks = 1